import { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";

import apiClient from "@toothfairy/shared-api/apiClient";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import AppAuth from "@toothfairy/shared-ui/AppAuthScreen";
import envConfig from "../../../envConfig";
import { makeGraphQLRequest } from "..";

// User operations use Lambda auth
const getUser = ({ id }) =>
  makeGraphQLRequest(graphqlOperation(queries.getUser, { id }));

const getUserByOwner = (owner) =>
  makeGraphQLRequest(
    graphqlOperation(queries.usersByOwner, { owner })
  );

const createUser = (userData) =>
  makeGraphQLRequest({
    query: mutations.createUser,
    variables: { input: userData },
  });

const listUsers = (limit = 100) =>
  makeGraphQLRequest(
    graphqlOperation(queries.listUsers, { limit })
  );

const updateUser = async (userData) => {
  const original = await getUser({ id: userData?.id });
  return makeGraphQLRequest({
    query: mutations.updateUser,
    variables: {
      input: {
        id: userData?.id,
        _version: original?.data?.getUser?._version,
        ...userData,
      },
    },
  });
};

const permanentlyDeleteUser = (id, _version) =>
  makeGraphQLRequest({
    query: mutations.deleteUser,
    variables: { input: { id, _version } },
  });

// getUserByEmail uses a custom resolver - keeping Lambda auth for consistency
const getUserByEmail = (email) =>
  makeGraphQLRequest(
    graphqlOperation(queries.getUserIDByEmail, { email: email?.toLowerCase() })
  );

const getAvailableChats = async (userid, workspaces) => {
  const payload = await AppAuth.getCurrentSession();
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/users/get-available-chats-to-user?userid=${userid}&workspaces=${workspaces}`;
  return secureRequest(
    apiClient.apiClient,
    "GET",
    url,
    null,
    null,
    true,
    null,
    payload
  );
};

const findVoucher = async (voucher) => {
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/users/get-available-vouchers`;
  const payload = await AppAuth.getCurrentSession();
  const requestBody = {
    voucherId: voucher,
  };
  return secureRequest(
    apiClient.apiClient,
    "POST",
    url,
    null,
    requestBody,
    true,
    null,
    payload
  );
};

const createWorkspaceUser = (workspaceID, userID, userType) =>
  makeGraphQLRequest({
    query: mutations.createUserWorkspaceType,
    variables: { input: { workspaceID, userID, userType } },
  });

const deleteWorkspaceUser = (id, _version) =>
  makeGraphQLRequest({
    query: mutations.deleteUserWorkspaceType,
    variables: { input: { id, _version } },
  });

const updateWorkspaceUser = (id, _version, userType, favoriteAgents) =>
  makeGraphQLRequest({
    query: mutations.updateUserWorkspaceType,
    variables: {
      input: {
        id,
        userType,
        _version,
        ...(favoriteAgents !== undefined && { favoriteAgents }),
      },
    },
  });

const updateUserFavoriteAgents = (id, _version, favoriteAgents) =>
  makeGraphQLRequest({
    query: mutations.updateUserWorkspaceType,
    variables: { input: { id, favoriteAgents, _version } },
  });

const updateRecentLocalFolders = (id, _version, recentLocalFolders) =>
  makeGraphQLRequest({
    query: mutations.updateUserWorkspaceType,
    variables: { input: { id, recentLocalFolders, _version } },
  });

const getWorkspaceUsersByWorkspaceID = (workspaceID, limit, nextToken) =>
  makeGraphQLRequest({
    query: queries.userToWorkspaceMapping,
    variables: { workspaceID, limit, ...(nextToken && { nextToken }) },
  });

export default {
  getUser,
  createUser,
  updateUser,
  listUsers,
  getUserByEmail,
  permanentlyDeleteUser,
  getAvailableChats,
  createWorkspaceUser,
  deleteWorkspaceUser,
  updateWorkspaceUser,
  updateUserFavoriteAgents,
  updateRecentLocalFolders,
  getWorkspaceUsersByWorkspaceID,
  getUserByOwner,
  findVoucher,
};
